import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// import ChangeViewArrayWithoutRouter from '../ChangeViewArrayWithoutRouter';
import ChangeViewArray from '../ChangeViewArray';
import DocIcon from '../../icons/DocIcon';
import VideoIcon from '../../icons/VideoIcon';
import RateIcon from '../../icons/RateIcon';
import AddAllAppsIcon from '../../icons/AddAllAppsIcon';
import OutsourcingIcon from '../../icons/OutsourcingIcon';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import CardManager from '../CardManager';
import axios from 'axios';
import ShareIcon from '../../icons/ShareIcon';
import AllAppsTile from '../Applications/AllAppsTile';
import AllAppsTable from '../Applications/AllAppsTable';
import AllAppsTbl from '../Applications/AllAppsTbl';
import SkeletonReviewContent from '../Skeleton/SkeletonReviewContent';
import SkeletonCardTable from '../Skeleton/SkeletonCardTable';
import SkeletonCardTile from '../Skeleton/SkeletonCardTile';
import SkeletonCardManager from '../Skeleton/SkeletonCardManager';
import mail from '../../other/config.json';
import Link from '@material-ui/core/Link';
import BasketAskCFT from "../Basket/BasketAskCFT";
import translate from '../../other/translate.json';
import Tooltip from '@material-ui/core/Tooltip';
import Pagination from '@material-ui/lab/Pagination';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import Snackbar from '@material-ui/core/Snackbar';
import PrimaryButton from '../PrimaryButton';
import config from '../../other/config';
import KloBanksChoose from '../KloBanksChoose';
import CustomSelect from '../CustomSelect';
const { serverAPI } = config;



export default function SolutionsContent(props) {
  let { bank } = useParams();
  let { basketChips } = props;
  const lang = localStorage.getItem('language') || 'Ru'
  let IsRu = lang === 'Ru'
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [bankinfo, setBankinfo] = useState([]);
  const [cardArr, setCardArr] = useState([]);
  const [cardAllArr, setCardAllArr] = useState([]);
  const [loading, setloading] = useState(true);
  // const [listNum, setListNumProps] = useState(0);
  const [ID, setID] = useState(null);
  const [stateAsk, setStateAsk] = React.useState(false);
  const [askCFT, setAskCFT] = useState(false);
  const [addXLSX, setAddXLSX] = useState(false);
  // const [allCardArr, setAllCardArr] = useState([]);
  const [countApp, setcountApp] = React.useState(0);
  const [countAllApp, setcountAllApp] = React.useState(0);
  const [snackbar, _snackbar] = React.useState([false, '']);
  let mailTo1 = `mailto:?subject=${mail['subjectShare']}&body=${encodeURIComponent(mail[`bodyShare_${lang}`]) + ' ' + window.location.href}`

  let [view, _view] = useState(localStorage.getItem('view') || 'table')
  let [allCheckBox, setAllCheckBox] = useState(false);
  let [checkAll, setCheckAll] = useState(false);
  const [page, setPage] = React.useState(1);
  const [disablePriorityBtn, _disablePriorityBtn] = useState([]);
  const [kloStatuses, _kloStatuses] = useState({});
  const [loadingKloStatuses, _loadingKloStatuses] = useState(false);
  const [sortingSelectVal, _sortingSelectVal] = useState('codeAsvulSortA');
  const kloUser = props.kloUser;
  const { currentBank } = kloUser;

  function changePage(event, value) {
    setPage(value);
    window.scrollTo(0, 0);
  };

  function setView(index) {
    if (index === 'tbl') setPage(1);
    _view(index)
    localStorage.setItem('view', index)
  }

  function handleModalAskCFT() {
    setAskCFT(true)
    setAddXLSX(false)
    setStateAsk(!stateAsk)
  }

  function closeSnackbar(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    _snackbar([false, '']);
  };


  // const handleStrockList = (index) => {
  //   setSelectedIndex(index);
  // };

  useEffect(() => {
    if (ID !== null) {
      let didCancel = false;
      async function fetchData() {

        if (!didCancel) {
          const _allcard = await axios.get(`${serverAPI}/solutionsv/${ID}/${lang}/${page - 1}/9999?inCu=${props.userCollection.inCu}`)
          if (_allcard && _allcard.data) {

            if (sortingSelectVal.at(-1) === 'A') {
              if (sortingSelectVal.slice(0, -1) === 'codeAsvulSort') {
                setCardArr(_allcard.data.neededApps)
              } else {
                setCardArr(_allcard.data.neededApps.sort((a, b) => a[sortingSelectVal.slice(0, -1)] < b[sortingSelectVal.slice(0, -1)] ? 1 : -1))
              }
            } else {
              if (sortingSelectVal.slice(0, -1) === 'codeAsvulSort') {
                setCardArr(_allcard.data.neededApps.reverse())
              } else {
                setCardArr(_allcard.data.neededApps.sort((a, b) => a[sortingSelectVal.slice(0, -1)] > b[sortingSelectVal.slice(0, -1)] ? 1 : -1))
              }
            }

            setloading(false)
            setcountApp((_allcard.data.neededApps && _allcard.data.neededApps[0] && _allcard.data.neededApps[0].count) || 0);
            // setCardArr(_allcard.data.neededApps)
            setcountAllApp((_allcard.data.neededApps && _allcard.data.neededApps[0] && _allcard.data.neededApps[0].count) || 0);
            setCardAllArr(_allcard.data.neededApps)
            props.userCollection.showTestId()
          }
        }
      }

      fetchData();
      return () => {
        didCancel = true;
      }
    }
  }, [bank, /*page, */ID, lang, sortingSelectVal]);

  useEffect(() => {
    let didCancel = false;
    async function fetchData() {
      setloading(true)
      const _bankinfo = await axios.get(`${serverAPI}/bankinfo/${bank}/${props.selectedIndex}/${lang}`)
      if (!didCancel) {
        if (_bankinfo && _bankinfo.data.length > 0 && _bankinfo.data) {
          setloading(false)
          setID(_bankinfo.data[0].ID)
          setBankinfo(_bankinfo.data[0])
          // let cur = _bankinfo.data[0].Currency;						
          // 	if (/*userCollection.inCu === '1' && ![0,2].includes(cur) || userCollection.inCu !== '1' && ![1,2].includes(cur)  */ cur !== 2){
          // 		//console.log('setCu', userCollection._CatalogCu)
          // 		userCollection._CatalogCu(cur === 1 ? '0' : '1')
          // 	}
        } else {
          props.setErr(true)
        }
      }
    }

    fetchData();
    return () => {
      didCancel = true;
    }
  }, [bank, lang, props.selectedIndex]);


  useEffect(() => {
    let didCancel = false;
    async function fetchData() {
      //console.log(cardArr,cardAllArr, view)
      if (cardArr.length > 0) {
        _loadingKloStatuses(true);
        const statuses = await props.getKloStatuses(cardAllArr.filter((elem, index) => { if (view === 'tbl') { return true } else { return index < page * 24 && index >= (page - 1) * 24 } }).map(el => el.codeasvul).join(','))
        //console.log(statuses)
        _kloStatuses(statuses);
        if (view !== 'tbl') {
          const statuses1 = await props.getKloStatuses(cardAllArr.map(el => el.codeasvul).join(','))

          _kloStatuses(statuses1);
        }
        _loadingKloStatuses(false);
      }
    }
    if (!didCancel) {
      fetchData();
    }
    return () => {
      didCancel = true;
    };
  }, [cardAllArr, currentBank]);

  // useEffect(() => {
  //   window.addEventListener("scroll", listener);
  //   return () => {
  //     window.removeEventListener("scroll", listener);
  //   };
  // }, [listNum]);


  // const listener = (e) => {
  //   if (window.pageYOffset > listNum * 1008 + 1000) {
  //     setListNumProps(listNum + 1)
  //   }
  // };

  function handleChangeSolutionTabs(event, newValue) { // а нам ничего не приходит codeerr
    setValue(newValue);
  };

  const SolutionsTabs = withStyles({
    indicator: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      height: 3,

      '& > span': {
        // maxWidth: 40,
        width: '100%',
        height: 3,
        backgroundColor: '#24262A',
      },
    },
  })((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

  const SolutionsTab = withStyles((theme) => ({
    root: {
      textTransform: 'none',
      color: '#24262A',
      fontWeight: '400', // theme.typography.fontWeightRegular,
      fontSize: '16px', // theme.typography.pxToRem(15),
      // marginRight: theme.spacing(1),
      borderBottom: '1px solid #BCBBD0',

      '&:focus': {
        opacity: 1,
      },

      '&:first-child': {
        minWidth: 75,
      }
    },
  }))((props) => <Tab disableRipple {...props} />);

  function uniqueArr(arr) {
    let result = [];

    for (let str of arr) {
      if (!result.includes(str)) {
        result.push(str);
      }
    }

    return result;
  }

  const choiseAll = async () => {
    const _card = await axios.get(`${serverAPI}/solutionsidv/${ID}/${lang}/${page - 1}`)
    if (_card && _card.data && _card.data.length > 0) {
      let newCardID = _card.data.filter(el => !props.userCollection.appCartInProduct.includes(el));
      let basketApps_ = props.userCollection.appBasket;
      let basketApp = allCheckBox ? basketApps_.filter(item => !newCardID.includes(item)) : basketApps_.concat(newCardID.filter(item => !basketApps_.includes(item)));
      props.saveCollection(basketApp, 'app', 'cart', undefined, true);
      setCheckAll(!checkAll)
      if (!allCheckBox) {
        let deltaApps = basketApp.length - basketApps_.length;
        props.handleCloseCookieSnackbar();
        _snackbar([true, translate.Words[`ApplicationsHaveBeenAddedToTheCart${lang}`] + ': ' + deltaApps])
      }
    }
  }

  useEffect(() => {
    let basketProd = props.userCollection.appBasket.concat(props.userCollection.appCartInProduct) || [] || []
    let isAll = cardArr.every(el => basketProd.includes(el.ID))
    setAllCheckBox(isAll)
  }, [cardArr, checkAll, props.userCollection.appBasket]);

  useEffect(() => {
    if (window.innerWidth < 1366) {
      setView('tile')
    }
  }, [window.innerWidth]);

  function upPrioritySnackbar(ResearchMarketMails, codeasvul) {
    _snackbar([true, translate.Words[`HasBeenRaised${lang}`]])
    upPriority(ResearchMarketMails, codeasvul)
  }

  async function upPriority(ResearchMarketMails, codeasvul) {
    let toJson = ResearchMarketMails && ResearchMarketMails.length > 1 ? JSON.parse(ResearchMarketMails) : {}
    toJson[`${props.usname.email}`] = 1;

    // console.log(disablePriorityBtn, disablePriorityBtn.concat(codeasvul));

    _disablePriorityBtn(disablePriorityBtn.concat(codeasvul))

    const result = await axios.post(`${serverAPI}/uppriority`, { mails: JSON.stringify(toJson), asvul: codeasvul })
    if (result) { } // codeerr пока заглушка
  }

  const copyToClipboard = async () => {
    try {
      const permissions = await navigator.permissions.query({ name: "clipboard-write" })
      if (permissions.state === "granted" || permissions.state === "prompt") {
        await navigator.clipboard.writeText(mail[`linkShare_${lang}`] + ' ' + window.location.href);
        _snackbar([true, translate.Words[`CopiedToClipboard_${lang}`]]);
      } else {
        _snackbar([true, translate.Words[`NotAccessClipboard_${lang}`]]);
      }
    } catch (error) {
      _snackbar([true, translate.Words[`ErrorCopyingClipboard_${lang}`] + error]);
    };

    window.location.href = mailTo1;
  };

  return (
    <Grid
      container
      direction="column"
      justify="flex-start"
      alignItems="flex-start"
      className={classes.container}
    >
      <Grid /* panel/title */
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        style={{ minHeight: 82 }}
      >
        <Grid item>
          <Typography className={classes.Header}>{bankinfo && bankinfo[`Title`]}</Typography>
        </Grid>

        <Grid item>
          <SolutionsTabs
            value={value}
            onChange={handleChangeSolutionTabs}
            aria-label="simple tabs example"
          >
            <SolutionsTab label={translate.Words[`Overview${lang}`]}  {...a11yProps(0)} />
            {bankinfo && bankinfo[`Managers`] ? <SolutionsTab label={IsRu ? "Менеджеры проекта" : "Managers"} {...a11yProps(1)} /> : " "}
          </SolutionsTabs>
        </Grid>
        {/* <Link href="/basket" onClick={preventDefault} className={classes.Body1}>Сохранённые комплектации</Link> */}
      </Grid>

      <TabPanel value={value} index={0}>

        <Grid /* actions/subtitle */
          id='S111'
          container
          className={classes.container}
          // spacing={3}
          style={{ marginTop: 11, padding: 5 }}
        >
          {
            loading === true
              ?
              <SkeletonReviewContent />
              :
              <Grid item container direction="row" justify="space-between">
                <Grid item className={classes.serviceDescription}>
                  <Grid item style={{ marginTop: 11 }}>
                    <Typography component="p" className={classes.Body1}>
                      <div dangerouslySetInnerHTML={{ __html: bankinfo[`HTMLContent`] }}></div>
                      {/* {bankinfo && bankinfo[`BriefDescription_${lang}`]} */}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid item className={classes.SideActions}>
                  {IsRu && bankinfo && bankinfo.AboutPath && bankinfo.AboutPath.length > 4
                    ?
                    <a className={classes.link} href={`${serverAPI}/${bankinfo.HashCode}/about/${bankinfo.AboutPath}`} rel="noopener noreferrer" target="_blank">
                      <Grid item container direction="row">
                        <DocIcon fill={'#BCBBD0'} />
                        <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                          Информация по каталогу
                        </Typography>
                      </Grid>
                    </a>
                    :
                    ''}

                  {IsRu && bankinfo && bankinfo.VideoPath && bankinfo.VideoPath.length > 4 ?
                    <a href={`${serverAPI}/${bankinfo.HashCode}/video/${bankinfo.VideoPath}`} className={classes.link} rel="noopener noreferrer" target="_blank">
                      <Grid item container direction="row" style={{ marginTop: 20 }}>
                        <VideoIcon fill={'#BCBBD0'} />
                        <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                          Видео презентация
                        </Typography>
                      </Grid>
                    </a>
                    : ''}

                  {bankinfo && bankinfo.Outsourcing && bankinfo.Outsourcing.length > 4
                    ?
                    <a className={classes.link} href={bankinfo.Outsourcing} rel="noopener noreferrer" target="_blank">
                      <Grid item container direction="row" style={{ marginTop: 20 }}>
                        <RateIcon fill={'#BCBBD0'} />
                        <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                          {translate.Words[`Outsourcing_${lang}`]}
                        </Typography>
                      </Grid>
                    </a>
                    :
                    ''
                  }

                  {bankinfo && bankinfo.Tariff && bankinfo.Tariff.length > 4
                    ?
                    <a className={classes.link} href={bankinfo.Tariff} rel="noopener noreferrer" target="_blank">
                      <Grid item container direction="row" style={{ marginTop: 20 }}>
                        <OutsourcingIcon fill={'#BCBBD0'} />
                        <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                          {translate.Words[`PricePlans_${lang}`]}
                        </Typography>
                      </Grid>
                    </a>
                    :
                    ''
                  }
                </Grid>
              </Grid>
          }

          <Grid item container direction="row" justify="flex-start" alignItems="center" style={{ marginTop: 15 }}>
            {/* <Grid item style={{ marginRight: 16 }}>
              <a style={{ textDecoration: 'none' }} href={mailTo2}>
                <PrimaryButton height={55} text={translate.Words[`DiscussWithCFT${lang}`]}
                //  onClick={''} 
                />
              </a>
            </Grid> */}
            {/* { kloUser && kloUser.user && kloUser.user.IS_CFT === '1'
                    ?
                    null
                    : */}

            <Grid item style={{ marginRight: 16 }} >
              <BasketAskCFT
                usname={props.usname}
                setUsname={props.setUsname}
                isAuth={props.isAuth}
                setIsAuth={props.setIsAuth}
                stateAsk={stateAsk}
                setStateAsk={setStateAsk}
                AskCFT={askCFT}
                AddXLSX={addXLSX}
                submit={'ask'}
                link={`${serverAPI}/solutions_v4/${ID}?lang=${lang}`}
              />
              {/* <Link className={classes.PrimaryLink} onClick={() => handleModalAskCFT()}>{translate.Words[`DiscussWithCFT${lang}`]} </Link> */}
              <HtmlTooltip
                interactive
                disableFocusListener={props.isAuth}
                disableHoverListener={props.isAuth}
                disableTouchListener={props.isAuth}
                title={
                  lang === 'Ru'
                    ?
                    <Grid item style={{ fontSize: '14px !important' }}><a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Авторизуйтесь</a>, чтобы отправить сообщение</Grid>
                    :
                    <Grid item style={{ fontSize: '14px !important' }}>Please <a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Log in</a> to send message</Grid>
                }
              >
                <Grid item>
                  <PrimaryButton
                    disabled={!props.isAuth}
                    height={55}
                    text={translate.Words[`DiscussWithCFT${lang}`]}
                    onClick={() => handleModalAskCFT()}
                  />
                </Grid>
              </HtmlTooltip>
            </Grid>

            {/* } */}

            <CustomTooltip title={translate.Words[`ShareLink_${lang}`]}>
              <IconButton aria-label={translate.Words[`ShareLink_${lang}`]} onClick={() => copyToClipboard()} style={{ background: '#FFFFFF', boxShadow: '4px 4px 20px rgba(68, 113, 209, 0.12)', height: 48 }} className={classes.margin}>
                <ShareIcon fill={'#BCBBD0'} />
              </IconButton>
            </CustomTooltip>
          </Grid>
        </Grid>

        <Grid item container spacing={3} className={classes.block} style={{ marginTop: 76 }}>
          <Grid item container>
            <Grid
              item
              className={classes.search}
              style={{ flexGrow: 1 }}
            >
              <Typography className={classes.Title2}> {translate.Words[`Applications_${lang}`]}</Typography>
            </Grid>

            <Grid item style={{ paddingRight: 12 }}>
              <Button aria-label="delete" className={classes.margin} size="small" onClick={(e) => choiseAll(e)} style={{ height: 48, display: allCheckBox ? 'none' : '' }}>
                <AddAllAppsIcon fill={'#BCBBD0'} fontSize="inherit" />
                <Typography style={{ marginLeft: 16, color: '#8987A2', textTransform: 'none' }}>{translate.Words[`AddAllToBasket${lang}`]} </Typography>
              </Button>
            </Grid>

            <Grid item style={{ width: 224, display: view === 'tbl' ? 'none' : 'block' }}>
              <CustomSelect
                data={
                  [
                    { id: 'codeAsvulSortA', name: lang === 'Ru' ? 'По коду \u{1F856}' : 'By code \u{1F856}' }, // 🡖
                    { id: 'codeAsvulSortD', name: lang === 'Ru' ? 'По коду \u{1F855}' : 'By code \u{1F855}' }, // 🡕
                    { id: 'sortingdatestartsaleD', name: lang === 'Ru' ? 'По дате выпуска \u{1F855}' : 'By release date \u{1F855}' },
                    { id: 'sortingdatestartsaleA', name: lang === 'Ru' ? 'По дате выпуска \u{1F856}' : 'By release date \u{1F856}' },
                    { id: 'versionD', name: lang === 'Ru' ? 'По версии \u{1F855}' : 'By version \u{1F855}' },
                    { id: 'versionA', name: lang === 'Ru' ? 'По версии \u{1F856}' : 'By version \u{1F856}' },
                  ]
                }
                tooltip={translate.Words[`Sorting_${lang}`]}
                defaultValue={sortingSelectVal}
                func={(e) => _sortingSelectVal(e.target.value)}
              />
            </Grid>

            <Grid item className={classes.cntrChangeView}>
              {/* <ChangeViewArrayWithoutRouter selected={selectedIndex} handleStrockList={handleStrockList} />
               */}
              <ChangeViewArray
                selected={view === 'tile' ? 1 : view === 'table' ? 0 : 2}
                handleView={setView}
                page={window.innerWidth > 1365 ? 'applist' : ''}
              />
            </Grid>
          </Grid>

          {view === 'tile' ? loading === true
            ?
            <SkeletonCardTable />
            :
            <AllAppsTable
              setCheckAll={setCheckAll}
              checkAll={checkAll}
              basket={true}
              type={'solutions'}
              readLink={bankinfo && bankinfo.length > 0 && bankinfo.readLink}
              basketChips={basketChips}
              IsRu={IsRu}
              setIsRu={props.setIsRu}
              cardArr={cardArr.filter((elem, index) => { return index < page * 24 && index >= (page - 1) * 24 })}
              bank={props.bank}
              mt={'12px'}
              language={lang}
              upPriority={upPrioritySnackbar}
              page={page}
              disablePriorityBtn={disablePriorityBtn}
              usname={props.usname}
              kloStatuses={kloStatuses}
              kloUser={kloUser}
              loadingKloStatuses={loadingKloStatuses}
              userCollection={props.userCollection}
              saveCollection={props.saveCollection}
            />
            :
            view === 'table' ? loading === true
              ?
              <SkeletonCardTile />
              :
              <AllAppsTile
                setCheckAll={setCheckAll}
                checkAll={checkAll}
                basket={true}
                type={'solutions'}
                readLink={bankinfo && bankinfo.length > 0 && bankinfo.readLink}
                basketChips={basketChips}
                IsRu={IsRu}
                setIsRu={props.setIsRu}
                cardArr={cardArr.filter((elem, index) => { return index < page * 24 && index >= (page - 1) * 24 })}
                bank={props.bank}
                mt={'0px'}
                language={lang}
                upPriority={upPrioritySnackbar}
                disablePriorityBtn={disablePriorityBtn}
                usname={props.usname}
                kloStatuses={kloStatuses}
                kloUser={kloUser}
                loadingKloStatuses={loadingKloStatuses}
                userCollection={props.userCollection}
                saveCollection={props.saveCollection}
              />
              :
              <Grid item container spacing={3} style={{ marginTop: 12 }}>
                <AllAppsTbl
                  key={3}
                  countApp={countApp}
                  // arrayTag={arrayTag}
                  // setArrayTag={setArrayTag}
                  basket={true}
                  cart={false}
                  type={'solutions'}
                  readLink={bankinfo && bankinfo.length > 0 && bankinfo.readLink}
                  cardArr={cardAllArr}
                  bank={props.bank}
                  checkAll={checkAll}
                  setCheckAll={setCheckAll}
                  loading={loading}
                  upPriority={upPrioritySnackbar}
                  disablePriorityBtn={disablePriorityBtn}
                  usname={props.usname}
                  kloStatuses={kloStatuses}
                  kloUser={kloUser}
                  loadingKloStatuses={loadingKloStatuses}
                  userCollection={props.userCollection}
                  saveCollection={props.saveCollection}
                />
              </Grid>
          }
        </Grid>

        {view !== 'tbl' && countApp > 1
          ?
          <Grid item container style={{ display: Math.trunc((countApp - 1) / 24) > 0 || (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? '' : 'none', marginTop: 24, /*paddingLeft:13,*/alignItems: 'center' }} >
            {
              Math.trunc((countApp - 1) / 24) > 0
                ?
                <Pagination className={classes.newPagination} count={Math.trunc((countApp - 1) / 24) + 1} page={page} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePage} />
                :
                null
            }
            <KloBanksChoose kloUser={kloUser} _kloUser={props._kloUser} delta={Math.trunc((countApp - 1) / 24) === 0 && (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? 0.15 : 355} />

          </Grid>
          :
          null
        }
        {view !== 'tbl' && countApp > 1
          ?
          <Grid item id='paginationContainer-js' container style={{ display: Math.trunc((countApp - 1) / 24) > 0 || (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? '' : 'none', marginTop: 24, height: 64, position: 'fixed', bottom: '0px', background: '#F4F5FB', /*paddingLeft:13,*/alignItems: 'center' }} >
            {
              Math.trunc((countApp - 1) / 24) > 0
                ?
                <Pagination id='pagination2-js' className={classes.newPagination} count={Math.trunc((countApp - 1) / 24) + 1} page={page} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePage} />
                :
                null
            }
            <KloBanksChoose kloUser={kloUser} _kloUser={props._kloUser} delta={Math.trunc((countApp - 1) / 24) === 0 && (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? 0.15 : undefined} />

          </Grid>
          :
          null
        }

        <div>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            open={snackbar[0]}
            autoHideDuration={3000}
            onClose={closeSnackbar}
          // message="Приложение доавлено в корзину"
          // className={classes.root}
          >
            <Grid
              container
              direction="row"
              justify="flex-start"
              alignItems="center"
              className={classes.snackbarPostroot}
            >
              <Avatar style={{ height: 48, width: 48, background: 'rgba(255, 255, 255, 0.2)' }}>
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.75488 12.2105L10.7894 16L19.7549 7" stroke="white" stroke-width="2" stroke-linecap="round" />
                </svg>
              </Avatar>

              <Typography style={{ marginLeft: 16, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF', width: 'calc(100% - 64px)' }}>
                {snackbar[1]}
              </Typography>
            </Grid>
          </Snackbar>
        </div>
      </TabPanel >

      <TabPanel value={value} index={1}>
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="flex-start"
          className={classes.container}
        >
          <Grid item container className={classes.block} style={{ marginTop: 82 }}>
            <Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader} style={{ textAlign: 'center', width: '100%' }}>
              {translate.Words[`ReadytoAnswerYourQuestions${lang}`]}:
            </Typography>

            <Grid
              item
              container
              direction="row"
              justify="center"
              alignItems="flex-start"
              spacing={3}
              style={{ marginTop: 40 }}
            // style={{ maxWidth: 872, margin: '40px auto' }}
            >
              {loading === true
                ?
                <SkeletonCardManager />
                :
                bankinfo[`Managers`]
                  ?
                  bankinfo[`Managers`].split(';#;').map((item) => {
                    return (
                      <Grid item>
                        <CardManager data={item} />
                      </Grid>
                    )
                  })
                  :
                  ''
              }
            </Grid>
          </Grid>
        </Grid>
      </TabPanel>
    </Grid >
  );
}

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(60, 60, 86, 0.87)',
    color: 'rgba(255, 255, 255, 0.87)',
    maxWidth: 500,
    fontSize: theme.typography.pxToRem(12),
    borderRadius: '8px',
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 400,
    padding: 12,
    opacity: 0.5,

    '& a': {
      color: 'rgba(255, 255, 255, 0.87)',
    }
  },
}))(Tooltip);

const useStyles = makeStyles(theme => ({
  Header: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '40px',
    lineHeight: '50px',
    color: '#000000'
  },

  contentHeader: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '28px',
    lineHeight: '40px',
    textAlign: 'center',
    color: '#000000'
  },

  container: {
    margin: '72px auto 0',
    '&:first-child': {
      margin: '0 auto'
    },

    // [theme.breakpoints.down(696)]: {
    //   maxWidth: 'calc(312px * 1)',
    // },
    // [theme.breakpoints.between(696, 1032)]: {
    //   maxWidth: 'calc(323px * 2)',
    // },
    // [theme.breakpoints.between(1032, 1366)]: {
    //   maxWidth: 'calc(330px * 3)',
    // },
    // [theme.breakpoints.between(1366, 1702)]: {
    //   maxWidth: 'calc(327px * 3)',
    // },
    // [theme.breakpoints.up(1702)]: {
    //   maxWidth: 'calc(330px * 4)',
    // }
  },

  tHeader: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2',
    fontWeight: 400
  },

  search: {
    position: 'relative',
    borderRadius: 24,
    backgroundColor: 'transparent',
    marginLeft: 0,
    marginRight: theme.spacing(1),
    width: 'auto',
    height: 48,

    [theme.breakpoints.down(1366)]: {
      backgroundColor: 'transparent'
    }
  },

  newPagination: {
    display: 'flex',
    alignItems: 'center'
  },

  padding: {
    padding: theme.spacing(1)
  },

  cntrChangeView: {
    paddingLeft: 12,

    [theme.breakpoints.down(1366)]: {
      display: 'none'
    }
  },

  Body1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#24262A'
  },

  Title2: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '28px',
    lineHeight: '40px',
    color: '#000000'
  },

  Title4: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '28px',
    color: '#000000',
  },

  SideActions: {
    minWidth: 246,
    padding: '12px 26px',
    // width: 313,
    marginTop: 17,

    [theme.breakpoints.down(1032)]: {
      padding: 0,
      marginBottom: 60,
    }
  },

  serviceDescription: {
    padding: '11px 0px',
    maxWidth: 865,

    [theme.breakpoints.between(1032, 1702)]: {
      maxWidth: 670,
    },

    [theme.breakpoints.down(1032)]: {
      maxWidth: '100%'
    },
  },

  link: {
    textDecoration: 'none'
  },

  PrimaryLink: {
    // color: theme.palette.getContrastText(purple[500]), // ERRORBAG 1
    display: 'flex',
    backgroundColor: '#EB505E',
    boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
    borderRadius: '48px',
    textTransform: 'none',
    textDecoration: 'none',
    height: '100%',
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '55px',
    color: '#FFFFFF',                                     //// ERRORBAG 1
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    "&:hover": {
      backgroundColor: '#EB505E',
      textDecoration: 'none',
    }
  },

  btnFilter: {
    backgroundColor: '#FFF',
    borderRadius: '16px',
    '&:focus': {
      borderRadius: '16px'
    }
  },

  snackbarPostroot: {
    padding: 24,
    borderRadius: '16px',
    background: 'rgba(60, 60, 86, 0.9)',
  },
}));


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Grid
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: '100%' }}
    >
      {value === index && (
        <Box p={3} style={{ padding: 0, backgroundColor: 'transparent' }} >
          <Grid container id="a157" style={{ marginTop: 18 }}>{children}</Grid>
        </Box>
      )}
    </Grid>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(60, 60, 86, 0.8)',
    color: '#FFFFFF',
    boxShadow: 'none',
    padding: 12,
    borderRadius: 8,
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
  },
}))(Tooltip);